'use client';
import Desktop from '@/components/Desktop';
import DesktopHome from '@/components/DesktopHome';

export default function RootPage() {
  return (
    <Desktop>
      <DesktopHome />
    </Desktop>
  );
}